import type { TAgreementLinkState } from './types';

export const agreementLinkReducer = (state: TAgreementLinkState = null): TAgreementLinkState => {
  return state;
};
